import { render, staticRenderFns } from "./study-video.vue?vue&type=template&id=6168c91a"
import script from "./study-video.vue?vue&type=script&lang=js"
export * from "./study-video.vue?vue&type=script&lang=js"
import style0 from "./study-video.vue?vue&type=style&index=0&id=6168c91a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports